/**
 * Takes any value and returns it's most logical boolean value
 * @param value
 * @returns boolean
 */
export const toBoolean = (value: unknown): boolean =>
  !['false', 'undefined', 'null', '0', 'no', 'nan', ''].includes(
    `${value}`.toLowerCase(),
  );

export const formatYesNo = (
  value: boolean | null | undefined,
): string | undefined => {
  if (value == null) return undefined;
  return value ? 'Yes' : 'No';
};
